import zegebaFetch from "@zegeba/zegeba-fetch";

const request = (url, options, timeout = 60000) => {
	const accessToken = localStorage.getItem("access_token");

	if (accessToken) {
		options.headers = {
			...options.headers,
			"Authorization": accessToken
		};
	}
	return zegebaFetch(url, options, timeout);
};

export default request;



// WEBPACK FOOTER //
// ./src/libs/request.js